import { render, staticRenderFns } from "./conversation-tag-pop.vue?vue&type=template&id=3fdc5409&"
import script from "./conversation-tag-pop.vue?vue&type=script&lang=js&"
export * from "./conversation-tag-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports